/**
 * @file ManualTrigger
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { ViewPopoverTrigger } from '../../views/ViewPopoverTrigger';
import { Popper } from '../Popper';
export var ManualTrigger = Popper.withManualTrigger(ViewPopoverTrigger);